import { PublicKey } from '@solana/web3.js';
import { ACCOUNT_SIZE } from '@solana/spl-token';

const ACCOUNT_TYPE_SIZE = 1;
const TLV_HEADER_LEN = 4;

export const PERMANENT_DELEGATE_EXTENSION_TYPE = 12;
const PERMANENT_DELEGATE_TLV_DATA_LEN = 32;

export interface PermanentDelegateConfig {
  delegate: PublicKey | null;
}

export function parsePermanentDelegateFromMint(buffer: Buffer): PermanentDelegateConfig | null {
  const tlvStart = ACCOUNT_SIZE + ACCOUNT_TYPE_SIZE;
  if (buffer.length <= tlvStart) {return null;}

  let cursor = tlvStart;
  while (cursor + TLV_HEADER_LEN <= buffer.length) {
    const type = buffer.readUInt16LE(cursor);
    const length = buffer.readUInt16LE(cursor + 2);
    const dataStart = cursor + TLV_HEADER_LEN;
    const dataEnd = dataStart + length;
    if (dataEnd > buffer.length) {return null;}

    if (type === PERMANENT_DELEGATE_EXTENSION_TYPE) {
      if (length < PERMANENT_DELEGATE_TLV_DATA_LEN) {return null;}
      const delegateBytes = buffer.slice(dataStart, dataStart + 32);
      const isZero = delegateBytes.every((b) => b === 0);
      return { delegate: isZero ? null : new PublicKey(delegateBytes) };
    }

    if (type === 0 && length === 0) {
      cursor += TLV_HEADER_LEN;
      continue;
    }
    cursor = dataEnd;
  }

  return null;
}
